import React, { useEffect, useState } from "react";
import jsPDF from "jspdf";

function Result() {
  const [data, setData] = useState(null);

  useEffect(() => {
    setData(JSON.parse(localStorage.getItem("gd-result")));
  }, []);

  if (!data) return <div style={{ color: "white" }}>Loading...</div>;

  const generatePDF = () => {
    const doc = new jsPDF();

    doc.setFontSize(18);
    doc.text("AI GD Evaluation Report", 20, 20);

    doc.setFontSize(12);
    doc.text(`Date: ${data.date}`, 20, 35);
    doc.text(`Topic: ${data.topic}`, 20, 45);

    doc.setFontSize(14);
    doc.text(`Final Score: ${data.final_score}/10`, 20, 60);

    doc.text("Scores:", 20, 80);
    doc.text(`Attention: ${data.scores.attention}`, 25, 90);
    doc.text(`Confidence: ${data.scores.confidence}`, 25, 100);
    doc.text(`Posture: ${data.scores.posture}`, 25, 110);
    doc.text(`Integrity: ${data.scores.integrity}`, 25, 120);

    doc.text("Tips:", 20, 140);
    data.tips.forEach((t, i) => {
      doc.text(`- ${t}`, 25, 150 + i * 10);
    });

    doc.addPage();
    doc.text("Behavior Timeline:", 20, 20);

    (data.timeline || []).slice(0, 20).forEach((t, i) => {
      doc.text(t, 20, 30 + i * 10);
    });

    doc.save("GD_Report.pdf");
  };

  return (
    <div style={layout}>
      <h1>📊 AI Report</h1>

      <div style={card}>
        <p>Date: {data.date}</p>
        <p>Topic: {data.topic}</p>
      </div>

      <div style={score}>
        <h2>Final Score</h2>
        <h1>{data.final_score}/10</h1>
      </div>

      <div style={grid}>
        <Box title="Attention" value={data.scores.attention} />
        <Box title="Confidence" value={data.scores.confidence} />
        <Box title="Posture" value={data.scores.posture} />
        <Box title="Integrity" value={data.scores.integrity} />
      </div>

      {data.cheating && (
        <div style={warn}>
          ⚠️ Continuous gaze deviation detected
        </div>
      )}

      <div style={card}>
        <h3>Improvement Tips</h3>
        {data.tips.map((t, i) => (
          <p key={i}>➤ {t}</p>
        ))}
      </div>

      <div style={card}>
        <h3>Behavior Timeline</h3>
        {(data.timeline || []).slice(0, 10).map((t, i) => (
          <p key={i}>{t}</p>
        ))}
      </div>

      <button onClick={generatePDF} style={btn}>
        Download PDF
      </button>
    </div>
  );
}

const Box = ({ title, value }) => (
  <div style={mini}>
    <p>{title}</p>
    <h2>{value}</h2>
  </div>
);

const layout = { background: "#050505", color: "white", padding: "40px" };
const card = { background: "#111", padding: "20px", marginBottom: "20px" };
const score = { background: "#6366f1", padding: "20px", textAlign: "center" };
const grid = { display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: "10px" };
const mini = { background: "#111", padding: "10px", textAlign: "center" };
const warn = { color: "red" };
const btn = { marginTop: "20px", padding: "10px", background: "#6366f1", color: "white" };

export default Result;